import React from "react";
import { HOURS } from "../data/shop";

export const Hours = () => {
  const today = new Date().getDay();

  return (
    <div className="footer-block">
      <h3 className="footer-block__title">Hours</h3>
      <dl className="hours">
        {HOURS.map((entry, index) => (
          <div
            className={`hours__row${index === today ? " is-today" : ""}`}
            key={entry.day}
          >
            <dt>{entry.day}</dt>
            <dd>{entry.open}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
